import { createApp, markRaw } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import { createPinia } from 'pinia';
import { loadFonts } from '@/plugins/webfontloader';
import '@/assets/css/styles.css';

loadFonts();
const app =
  createApp(App)
  .use(createPinia().use(({ store }) => {
    store.$router = markRaw(router);
  }))
  .use(router);

app.config.globalProperties.$title = 'PipePro';
app.config.globalProperties.$version = '1.1.3 Beta';
app.mount('#app');